<div class="page-heading modal-content-header">
    <div class="layer-title">{{ header }}</div>
</div>

<div class="modal-content-body" [formGroup]="phaseFormGroup">
    <div class="form-row">
        <label for="firstname" class="required">Label</label>
        <ed-textfield
            innerId="Label"
            name="Label"
            type="text"
            placeholder="WP1 - XXX"
            [required]="true"
            [formControlName]="'label'"></ed-textfield>
    </div>
    <div class="form-row">

            <label for="researchCategoryId" class="required">Catégorie de recherche (optionnel)</label>
            <ed-search
            id="researchCategoryId"
            placeholder="Séléctionnez une catégorie"
            [formControlName]="'researchCategoryId'"
            [options]="researchCategoryOptions">
            </ed-search>                      
    
    </div>
</div>

<div class="layer-actions">
    <ed-button [colorSchema]="buttonColors.Secondary" (click)="close()">Retour</ed-button>
    <ed-button (click)="valid()" [disabled]="canCreateEdit()">Ajouter le projet</ed-button>
</div>